//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'
   v-loading="loadingSpinner"
   element-loading-text="Подождите">

  <div style="width:100%; float:left">
    <div style="float:left">
      <p style="font-size:16px; padding-top:0px;">Заявки</p>
    </div>
    <div style="margin-top:-5px; padding-left:5px; float:left">
      <Button type="text" size="small" style="border-radius:3px; margin-bottom:5px; padding-top:5px;" @click="reloadOnClick">
        <Icon type="ios-loop" size="18"></Icon>
      </Button>
    </div>
    <div style="float:right; margin:0 10px 0 7px; display:inline-block;">
      <Button type="dashed" style="border-radius:3px; height:36px; margin-bottom:0px; color:#b7b7b7; text-decoration2:underline;" size2="large" @click="showDeletedItemsChangeMode"><span v-if="showDeletedItemsMode==false">АРХИВ</span><span v-else>ВЕРНУТЬСЯ ИЗ АРХИВА</span></Button>
    </div>
  </div>

  <div v-if="serverData.loadingDataStatus.mainCommonData != serverData.loadingDataStatus.types.LOADED">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="serverData.loadingDataStatus.tasks != serverData.loadingDataStatus.types.LOADED">
    Подождите, загружаются данные по заявкам
  </div>
  <div v-else style="width:100%; float:left">

   <div :style="expandTable == true ? '' : ''" style="width:calc(100% - 750px); height:100%; padding-right:0px; float:left;">
   
    <div style="width:50px; padding-top:11px; padding-bottom:0px; display:inline-block; float:left;"><span>Фильтр</span></div>
    <div style="padding-bottom:12px; display:inline-block; width:235px">
      <Input v-model="filterValue" size="large" style="width:100%" v-on:on-change="filterValueOnChange"/>
    </div>
    <div style="margin-top:0px; display:inline-block; float2:left; width:160px">
      <select v-model="filterStatusValue" filterable placeholder="Выберите статус" style="width:100%; padding-top:2px; margin-left:3px; height:36px; background-color:#fff" @change="filterValueOnChange">
        <option value="">ВСЕ СТАТУСЫ</Option>
        <option v-for="(item, index) in serverData.appSettings.finix.finixOrdersStatuses" :value="item.id" :key="item.id">{{item.name}}</Option>
      </select>
    </div>

    <div style="float2:right; margin:0 10px 0 7px; display:inline-block;">
      <Button type="ghost" style="border-radius:3px; height:36px; margin-bottom:0px;" size="large" :disabled="(editingDataRow != null) && (editingDataRow.val.id == null)" @click="newEditingDataRowOnClick">+</Button>
    </div>

    <div v-if="showDeletedItemsMode == true" style="font-size:15px; padding-bottom:10px">
      АРХИВ ЗАЯВОК:
    </div>

    <div class="datalist">
      <table style="width:100%; padding-right:16px; padding-top:0px; border-spacing:0px;">
        <tr style="width:100%;">
          <th v-for="(column, keyColumn) in options.tableColumns" :key="keyColumn" :width="column.width"
           style="padding:0px 5px 5px 0px;font-weight:normal;border-bottom: 1px solid #ccc;" align="left">
            {{column.title}}
          </th>
          <th width="15px" align="left" style="font-weight:normal;border-bottom: 1px solid #ccc;"></th>
        </tr>
      </table>
      <div class="datalist-scroll">
        <table style="width:100%;padding-top:0px;border-spacing:0px;">
          <tr v-for="(itemData, keyData) in filteredRecords" :key="keyData" @click="dataRowOnSelect(itemData)" style="width:100%;height:32px;"
           :style="{background: isRowSelected(itemData) ? 'rgb(108,118,175)' : '#fff', color: isRowSelected(itemData) ? 'rgb(240,240,240)' : '#778087'}">
            <td v-for="(column, keyColumn) in options.tableColumns" :key="keyColumn" :width="column.width"
             style="font-size:12px;padding:2px 5px 2px 0px;" align="left">
              <span v-if="column.field == 'status'">
                {{serverData.appSettings.finix.finixOrdersStatusesMap[itemData.val.body.status]}}
              </span>
              <span v-else-if="(column.field == 'createdAt')">
                {{itemData.val.createdAt | formatDate}}
              </span>
              <span v-else-if="(column.field == 'client')">
                <span v-if="serverData.partnersGetOneById(itemData.val.body.finix.client) != null">
                  {{serverData.partnersGetOneById(itemData.val.body.finix.client).val.Name}}
                </span>
              </span>
              <span v-else-if="(column.field == 'bank')">
                <span v-if="serverData.finixBanksGetOneById(itemData.val.body.finix.bank) != null">
                  {{serverData.finixBanksGetOneById(itemData.val.body.finix.bank).val.name}}
                </span>
              </span>
              <span v-else-if="(column.field == 'saler')">
                <span v-if="commonData.users[itemData.val.body.finix.saler] != null">
                  {{commonData.users[itemData.val.body.finix.saler].Name}}
                </span>
              </span>
              <span v-else-if="(column.field == 'manager')">
                <span v-if="commonData.users[itemData.val.body.finix.manager] != null">
                  {{commonData.users[itemData.val.body.finix.manager].Name}}
                </span>
              </span>
              <span v-else>
                {{itemData.val[column.field]}}
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>

   </div>

   <div style="width:350px; padding: 44px 0px 10px 20px; border-left2:1px solid #ccc; float:left; min-height: calc(100vh - 130px)" :class="(expandTable == true) ? 'hidden2' : ''">

     <div v-if="editingDataRow != null">

        <div style="width:100%; padding-top:5px; padding-bottom:20px; display:inline-block; float:left;">
          <span v-if="editingDataRow.val.id != null"><b>РЕДАКТИРОВАНИЕ :</b></span>
          <span v-else><b>НОВАЯ ЗАЯВКА :</b></span>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Название</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.name" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Статус</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <select v-model="editingDataRow.val.body.status" filterable placeholder="Выберите статус" style="width:100%; height:32px; background-color:#fff">
            <option v-for="(item, index) in serverData.appSettings.finix.finixOrdersStatuses" :value="item.id" :key="item.id">{{item.name}}</Option>
          </select>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Банк</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <select v-model="editingDataRow.val.body.finix.bank" filterable placeholder="Выберите банк" style="width:100%; height:32px; background-color:#fff">
            <option v-for="(item, index) in serverData.finixBanks" :value="item.val.id" :key="item.val.id">{{item.val.name}}</Option>
          </select>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Продавец</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <select v-model="editingDataRow.val.body.finix.saler" filterable placeholder="Выберите пользователя" style="width:100%; height:32px;"
          :style="((activeUser.GroupID != serverData.appSettings.finix.userGroups.ADMINS) && (activeUser.GroupID != serverData.appSettings.finix.userGroups.DIRECTORS)) ? 'background-color:#eee' : 'background-color:#fff'"
          :disabled="((activeUser.GroupID != serverData.appSettings.finix.userGroups.ADMINS) && (activeUser.GroupID != serverData.appSettings.finix.userGroups.DIRECTORS)) ? true : false">
            <option v-for="(item, index) in commonData.users" :value="item.id" :key="item.id" v-if="(item.GroupID <= serverData.appSettings.finix.userGroups.SALERS) && (item.Deleted == 0)">{{item.Name}}</Option>
          </select>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Менеджер</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <select v-model="editingDataRow.val.body.finix.manager" filterable placeholder="Выберите пользователя" style="width:100%; height:32px;"
          :style="((activeUser.GroupID != serverData.appSettings.finix.userGroups.ADMINS) && (activeUser.GroupID != serverData.appSettings.finix.userGroups.DIRECTORS)) ? 'background-color:#eee' : 'background-color:#fff'"
          :disabled="((activeUser.GroupID != serverData.appSettings.finix.userGroups.ADMINS) && (activeUser.GroupID != serverData.appSettings.finix.userGroups.DIRECTORS)) ? true : false">
            <option v-for="(item, index) in commonData.users" :value="item.id" :key="item.id" v-if="item.GroupID == (serverData.appSettings.finix.userGroups.MANAGERS) && (item.Deleted == 0)">{{item.Name}}</Option>
          </select>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Дата создания</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <DatePicker v-model="editingDataRow.val.createdAt" type="date" placeholder="Выберите дату" style="width:100%"></DatePicker>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Закон</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <select v-model="editingDataRow.val.body.finix.zakon" filterable placeholder="Выберите банк" style="width:100%; height:32px; background-color:#fff">
            <option v-for="(item, index) in serverData.appSettings.finix.finixOrdersZaroni" :value="item" :key="item">{{index}}</Option>
          </select>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Вид заявки</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <select v-model="editingDataRow.val.body.finix.zakon" filterable placeholder="Выберите банк" style="width:100%; height:32px; background-color:#fff">
            <option v-for="(item, index) in serverData.appSettings.finix.finixOrdersVidi" :value="item" :key="item">{{index}}</Option>
          </select>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Тип заявки</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <select v-model="editingDataRow.val.body.finix.zakon" filterable placeholder="Выберите банк" style="width:100%; height:32px; background-color:#fff">
            <option v-for="(item, index) in serverData.appSettings.finix.finixOrdersTipi" :value="item" :key="item">{{index}}</Option>
          </select>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Ссылка на тендер</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.body.finix.ssilka" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Сумма заявки</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.body.finix.summa" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Срок заявки</span></div>
        <div style="padding-bottom: 10px; display:inline-block; float:left; width:110px">
          <DatePicker v-model="editingDataRow.val.body.finix.srokOt" type="date" placeholder="Выберите дату" style="width:100%"></DatePicker>
        </div>
        <div style="margin-left:10px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 220px)">
          <DatePicker v-model="editingDataRow.val.body.finix.srokDo" type="date" placeholder="Выберите дату" style="width:100%"></DatePicker>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Аванс (%)</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.body.finix.avancProcent" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Аванс (руб)</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.body.finix.avancRub" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>Бесспорное</span></div>
        <div style="margin:2px 0 5px 0;padding-bottom:0px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Checkbox v-model="editingDataRow.val.body.finix.besspornoe" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Предмет контракта</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.body.finix.predmet" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:0px; display:inline-block; float:left;"><span>Срочно</span></div>
        <div style="margin:2px 0 5px 0;padding-bottom:0px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Checkbox v-model="editingDataRow.val.body.finix.srochno" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Площадка</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <Input v-model="editingDataRow.val.body.finix.ploschadka" style="width:100%"></Input>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;" v-if="editingDataRow.val.id != null"><span>Номер</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)" v-if="editingDataRow.val.id != null">
          {{editingDataRow.val.id}}&nbsp;
        </div>

        <div style="padding: 15px 0px 0px 0px;">
          <Button type="warning" style="border-radius:3px; margin-bottom:10px;" @click="saveEditingDataRowOnClick">Сохранить</Button>
          <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="cancelEditingDataRowOnClick">Отменить</Button>
          <Button type="ghost" style="float:right; border-radius:3px; margin-bottom:10px; padding-top:5px; color:#d7d7d7;" :class="editingDataRow.val.id == null ? 'hidden' : ''" @click="deleteEditingDataRowOnClick">
            <Icon type="trash-b" size="18"></Icon>
            <Icon type="ios-redo" size="18" v-if="editingDataRow.val.deleted == true"></Icon>
          </Button>
        </div>

     </div>

     <div v-else>
       <br><br><br>
       * Выберите запись для просмотра или редактирования
       <br><br><br>
     </div>

   </div>

   <div style="width:350px; margin-left:10px; padding: 44px 0px 10px 20px; border-left2:1px solid #ccc; float:left; min-height: calc(100vh - 130px)" :class="(expandTable == true) ? 'hidden2' : ''">

     <div v-if="editingDataRow != null">

        <div style="width:100%; padding-top:5px; padding-bottom:20px; display:inline-block; float:left;">
          <span>КЛИЕНТ :</span>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Название</span></div>
        <div style="padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <select v-model="editingDataRow.val.body.finix.client" filterable placeholder="Выберите клиента" style="width:100%; height:32px; background-color:#fff">
            <option v-for="(item, index) in serverData.partners" :value="item.val.id" :key="item.id" v-if="(item.val.ClientOrSupplier != 2) && (item.val.Deleted == 0)">{{item.val.Name}}</Option>
          </select>
        </div>

        <!--br>
        {{editingDataRow.val.body}}
        <br><br><br><br><br>
        {{data[1].val.body}}
        <br-->
        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>ИНН</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <span v2-if2="(editingDataRow.val.body.finix.client != '')">
            {{(serverData.partnersGetOneById(editingDataRow.val.body.finix.client) != null) ? serverData.partnersGetOneById(editingDataRow.val.body.finix.client).val.INN : ''}}&nbsp;
            <!--span>--- {{editingDataRow.val.body}}&nbsp;</span-->
          </span>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>ОГРНН</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <span v2-if2="(editingDataRow.val.body.finix.client != '')">
            {{(serverData.partnersGetOneById(editingDataRow.val.body.finix.client) != null) ? serverData.partnersGetOneById(editingDataRow.val.body.finix.client).val.OGRNN : ''}}&nbsp;
          </span>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>КПП</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <span v2-if2="(editingDataRow.val.body.finix.client != '')">
            {{(serverData.partnersGetOneById(editingDataRow.val.body.finix.client) != null) ? serverData.partnersGetOneById(editingDataRow.val.body.finix.client).val.KPP : ''}}&nbsp;
          </span>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Телефон</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <span v2-if2="(editingDataRow.val.body.finix.client != '')">
            {{(serverData.partnersGetOneById(editingDataRow.val.body.finix.client) != null) ? serverData.partnersGetOneById(editingDataRow.val.body.finix.client).val.Phone : ''}}&nbsp;
          </span>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Email</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <span v2-if2="(editingDataRow.val.body.finix.client != '')">
            {{(serverData.partnersGetOneById(editingDataRow.val.body.finix.client) != null) ? serverData.partnersGetOneById(editingDataRow.val.body.finix.client).val.Email : ''}}&nbsp;
          </span>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Контак.лицо</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <span v2-if2="(editingDataRow.val.body.finix.client != '')">
            {{(serverData.partnersGetOneById(editingDataRow.val.body.finix.client) != null) ? serverData.partnersGetOneById(editingDataRow.val.body.finix.client).val.ContactName : ''}}&nbsp;
          </span>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Город</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <span v2-if2="(editingDataRow.val.body.finix.client != '')">
            {{(serverData.partnersGetOneById(editingDataRow.val.body.finix.client) != null) ? serverData.partnersGetOneById(editingDataRow.val.body.finix.client).val.City : ''}}&nbsp;
          </span>
        </div>

        <div style="width:100px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Адрес</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 100px)">
          <span v2-if2="(editingDataRow.val.body.finix.client != '')">
            {{(serverData.partnersGetOneById(editingDataRow.val.body.finix.client) != null) ? serverData.partnersGetOneById(editingDataRow.val.body.finix.client).val.Address : ''}}&nbsp;
          </span>
        </div>

     </div>

   </div>

  </div>
  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import arrayTools from '@/technical/arrayTools/arrayTools'

import serverData from '@/store/serverData'

export default {
  components: { },
  data () {
    return {
      // usersAccessAsOffice: {'5': true, '7': true, '8': true, '11': true, '95': true}, // Тюрин, Ремезова, Малюгина, Егор, Белов

      data: [], // list of FinixTasks
      filteredRecords: [],

      // UI FIELDS
      showDeletedItemsMode: false,

      serverData: serverData, // to make access from UI template

      options: {
        tableColumns: [
          {title: '', width: '5px', field: ''},
          {title: '#', width: '40px', field: 'id'},
          {title: 'Название', width: '', field: 'name'},
          {title: 'Статус', width: '120px', field: 'status'},
          {title: 'Клиент', width: '120px', field: 'client'},
          {title: 'Банк', width: '120px', field: 'bank'},
          {title: 'Продавец', width: '100px', field: 'saler'},
          {title: 'Менеджер', width: '100px', field: 'manager'},
          {title: 'Создано', width: '70px', field: 'createdAt'}
        ]
      },

      filterValue: '',
      filterStatusValue: '',

      expandTable: true,

      loadingSpinner: false,

      selectedDataRow: null,
      editingDataRow: null
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser',
      'commonData'
    ])
  },
  created: function () {
    var thisRef = this
    this.data = serverData.tasks // если перезаугрузка данной страницы то тут ничего еще не загружено и пусто. получаем через event FinixTasksChanged

    // ниже две подписки нужны чпотому что неизвестно что из tasks и общих данных загрузится быстрее. а нужны оба чтобы вызвать filterValueOnChange() иначе будет ошибка. а например в случае если перегружается конкретно этот урл то tasks быстрее приходят
    // вообще тут бы метод у serverData.callMeWhenTheseLoaded(['mainCommonData', 'tasks']). там же serverData сам вызывает reload у того, что еще не загружено
    serverData.eventsBus.$on('mainCommonDataLoaded', (data) => {
      if (serverData.loadingDataStatus.tasks === serverData.loadingDataStatus.types.LOADED) thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    })

    serverData.eventsBus.$on('tasksChanged', (data) => {
      // console.log('on tasksChanged')
      // console.log(data)
      // console.log(this.data)
      /* if (this.editingDataRec.val.id === data.record.id) {
        this.editingDataRec.val = Object.assign({}, data.record)
      } */
      if (serverData.loadingDataStatus.mainCommonData === serverData.loadingDataStatus.types.LOADED) thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    })

    // если это не перезагрузка данной страницы то serverData уже давно бы был и тут бы мы строили список наших отображаемых данных
    // но это только для CommonData, т е тех что загружаются в приложени по умолчанию. а наши данные надо тут указать что грузим
    // thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    serverData.tasksReload(function (err) {
      if (err) return serverErrorHandling(err, thisRef)
    }) // вместо callback функционал сработает через serverData.eventsBus.$on('tasksChanged')

    serverData.tasksOnDestroyDelegates.push(this.deleteDataRecDelegate)
  },
  methods: {
    ...mapMutations([
      'commonDataIsLoadedSet'
    ]),
    reloadOnClick () {
      var thisRef = this
      // thisRef.data = [] // трется внутри serverData.reload

      this.selectedDataRow = null
      this.editingDataRow = null
      this.expandTable = true

      serverData.tasksReload(function (err) {
        if (err) return serverErrorHandling(err, thisRef)
        // вместо этих строк работает serverData.eventsBus.$on('tasksChanged', (data))
        // thisRef.data = serverData.tasks // data так и смотрела на serverData которые не перезаписывались а стирались и добавлялись
        // thisRef.filterValueOnChange()
      })
    },
    filterValueOnChange () {
      this.filteredRecords.splice(0, this.filteredRecords.length)

      if (this.data.length === 0) return

      for (let i = this.data.length - 1; i >= 0; i--) {
        if (this.data[i].val.belongsToBoard !== serverData.appSettings.finix.finixOrdersTaskBoard) continue // Убираем тех что не на доске заявок
        if (this.data[i].val.type !== serverData.appSettings.tasks.taskTypes.FINIX_ORDER) continue // Убираем тех что НЕ ЗАЯВКИ

        if ((this.showDeletedItemsMode === false) && (this.data[i].val.deleted === true)) continue // НЕ ИЩЕМ В АРХИВИРОВАННЫХ
        if ((this.showDeletedItemsMode === true) && (this.data[i].val.deleted === false)) continue // НЕ ИЩЕМ НЕ В АРХИВИРОВАННЫХ

        if ((this.activeUser.GroupID === serverData.appSettings.finix.userGroups.SALERS) && (this.data[i].val.body.finix.saler !== this.activeUser.id)) continue // НЕ ПОКАЗЫВАЕМ ПРОДАВЦАМ заявки которые не они не продавцы
        if ((this.activeUser.GroupID === serverData.appSettings.finix.userGroups.MANAGERS) && (this.data[i].val.body.finix.manager !== this.activeUser.id)) continue // НЕ ПОКАЗЫВАЕМ МЕНЕДЖЕРАМ заявки которые не они не менеджеры

        if ((this.filterStatusValue !== '') && (this.filterStatusValue !== this.data[i].val.body.status)) continue

        if (this.filterValue.length === 0) {
          this.filteredRecords.push(this.data[i])
          continue
        }

        if (this.data[i].val.id.toString().indexOf(this.filterValue) !== -1) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        var filterValueLowerCase = this.filterValue.toLowerCase()
        if ((this.data[i].val.name != null) && (this.data[i].val.name.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.body.finix.client != null) &&
            (this.serverData.partnersGetOneById(this.data[i].val.body.finix.client) != null) &&
            (this.serverData.partnersGetOneById(this.data[i].val.body.finix.client).val.Name.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.body.finix.saler != null) && (this.commonData.users[this.data[i].val.body.finix.saler] != null) && (this.commonData.users[this.data[i].val.body.finix.saler].Name.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.body.finix.manager != null) && (this.commonData.users[this.data[i].val.body.finix.manager] != null) && (this.commonData.users[this.data[i].val.body.finix.manager].Name.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.body.finix.bank != null) &&
            (this.serverData.finixBanksGetOneById(this.data[i].val.body.finix.bank) != null) &&
            (this.serverData.finixBanksGetOneById(this.data[i].val.body.finix.bank).val.name.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
      }

      arrayTools.sort(this.filteredRecords, function (a, b) {
        return a.val.id < b.val.id
      })
    },

    newEditingDataRowOnClick () {
      var newEntity = restResource(this.appSettings.server.host + this.appSettings.server.taskResource)
      newEntity.val = {}
      newEntity.val.name = ''
      newEntity.val.type = serverData.appSettings.tasks.taskTypes.FINIX_ORDER
      newEntity.val.belongsToBoard = serverData.appSettings.finix.finixOrdersTaskBoard
      newEntity.val.parentTask = null
      newEntity.val.body = {}
      newEntity.val.body.status = 1 // NEW
      newEntity.val.body.finix = {}
      newEntity.val.body.finix.client = 0
      newEntity.val.body.finix.manager = 0
      newEntity.val.body.finix.saler = this.activeUser.id
      newEntity.val.body.finix.bank = 0
      newEntity.val.deleted = false // Not deleted
      newEntity.val.createdAt = new Date()
      newEntity.val.updatedAt = new Date()

      this.selectedDataRow = null
      this.editingDataRow = {}
      this.editingDataRow = Object.assign({}, newEntity)
      this.editingDataRow.val = Object.assign({}, newEntity.val)
      this.editingDataRow.val.body = Object.assign({}, newEntity.val.body)
      this.editingDataRow.val.body.finix = Object.assign({}, newEntity.val.body.finix)

      this.expandTable = false // to show newEntity editing
    },

    cancelEditingDataRowOnClick () {
      this.selectedDataRow = null
      this.editingDataRow = null
      this.expandTable = true
    },

    saveEditingDataRowOnClick () {
      // if (this.editingDataRow.val.name === '') return this.$message.error('Введите название')

      var thisRef = this

      thisRef.loadingSpinner = true
      const loading = thisRef.$loading({
        lock: true,
        text: 'Подождите, идет сохранение данных'
      })

      thisRef.editingDataRow.save()
      .then(function (response) {
        thisRef.loadingSpinner = false
        loading.close()

        thisRef.selectedDataRow = null
        thisRef.editingDataRow = null
        thisRef.expandTable = true

        /* thisRef.dataIsLoaded = 1 // т к appSettings мы не перегружаем и эти данные уже есть
        serverData.tasksReload(function (err) {
          if (err) return serverErrorHandling(err, thisRef)
          // thisRef.data = serverData.tasks
          // thisRef.filterValueOnChange()
        }) */

        // thisRef.$message.success('Запись сохранена на сервер')
      })
      .catch(function (error) {
        thisRef.loadingSpinner = false
        loading.close()
        serverErrorHandling(error, thisRef)
      })
    },

    deleteEditingDataRowOnClick () {
      if (this.editingDataRow.val.deleted === false) this.editingDataRow.val.deleted = true // delete (archive)
      else this.editingDataRow.val.deleted = false // undelete (return from archive trashbox)

      this.saveEditingDataRowOnClick()
      // this.filterValueOnChange()

      this.selectedDataRow = null
      this.editingDataRow = null
      this.expandTable = true
    },

    deleteDataRecDelegate (deletedRecord, cb) {
      /* var thisRef = this
      if ((thisRef.editingDataRec != null) && (deletedRecord.id === thisRef.editingDataRec.val.id)) {
        thisRef.editingDataRec = null
      } */
      return cb()
    },

    showDeletedItemsChangeMode () {
      this.showDeletedItemsMode = !this.showDeletedItemsMode
      this.selectedDataRow = null
      this.editingDataRow = null
      this.expandTable = true
      this.filterValueOnChange()
    },

    dataRowOnSelect (value) {
      // console.log(value.val.body.finix)
      this.selectedDataRow = value
      // delete this.editingDataRow
      // this.editingDataRow = null
      this.editingDataRow = Object.assign({}, value)
      this.editingDataRow.val = Object.assign({}, value.val)
      this.editingDataRow.val.body = Object.assign({}, value.val.body)
      this.editingDataRow.val.body.finix = Object.assign({}, value.val.body.finix)
      // this.editingDataRow.val.body.finix.client = 0
      // this.editingDataRow.val.body.finix.client = value.val.body.finix.client
      // console.log(this.editingDataRow.val.body.finix)
      this.expandTable = false
    },

    isRowSelected (row) {
      if (this.selectedDataRow == null) return false
      if (row.val.id === this.selectedDataRow.val.id) return true
      else return false
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.top-panel-expand-table-button {
  margin: 0px;
  pading: 0px;
  font-size: 17px;
  color: #5a5a5a;
  cursor: pointer;
}
.top-panel-expand-table-button:hover {
  color: #000;
}
.datalist{
  height: 100%;
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.datalist-scroll {
  overflow-y: scroll;   /* надо чтобы работал scroll для mainMenu */
  height: calc(100vh - 200px);
  /* width: 257px; /* минимум на 17 пикселей больше чем mainmenu-panel.width, ща сделал на 50 больше */
}
hr {
  /*border: none; /* Убираем границу для браузера Firefox */
  /*color: #ccc; /* Цвет линии для остальных браузеров */
  /*background-color: #ccc; /* Цвет линии для браузера Firefox и Opera */
  /*height: 1px; /* Толщина линии */
  margin: 10px 0 15px 0;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
.incomesAndExpensesTextarea textarea.ivu-input {
  font-size: 12px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// FinixTasks.vue?649af2cd